// TODO: Add unit tests

export function initGoogletag() {
  window.googletag = window.googletag || { cmd: [] }
}

export function setNonPersonalizedAds(nonPersonalizedAds: boolean) {
  window.googletag.cmd.push(() => {
    window.googletag.pubads().setPrivacySettings({ nonPersonalizedAds })
  })
}

export function setAdsSegments(adsSegments: Record<string, string>) {
  if (!Object.keys(adsSegments).length) return

  window.googletag.cmd.push(() => {
    Object.entries(adsSegments).forEach(([key, value]) =>
      window.googletag.pubads().setTargeting(key, value),
    )
  })
}

function getBidderTimeoutTargeting(abTestVariant: string) {
  if (abTestVariant === 'a') return 'bidder_timeout_2000'
  if (abTestVariant === 'b') return 'bidder_timeout_1000'

  return 'bidder_timeout_off'
}

export function setAbTestTargetingForPubstack(abTestVariant?: string) {
  if (!abTestVariant) return

  window.googletag.cmd.push(() => {
    window.googletag
      .pubads()
      .setTargeting('pbstck_ab_test', getBidderTimeoutTargeting(abTestVariant))
  })
}

export function setupGoogletagServices() {
  window.googletag.cmd.push(() => {
    window.googletag.pubads().enableSingleRequest()
    window.googletag.pubads().disableInitialLoad()
    window.googletag.pubads().collapseEmptyDivs()

    window.googletag.enableServices()
  })
}
